import { createSlice } from "@reduxjs/toolkit";
import { existingRegistrations as initialState } from "../initialState";

export const slice = createSlice({
    name: "existingRegistrations",
    initialState,
    reducers: {
        replaceExistingRegistrations: (state, action) => action.payload,
    },
});

// actions
export const { replaceExistingRegistrations } = slice.actions;

// selectors
export const selectExistingRegistrations = (state) =>
    state.existingRegistrations;

export const selectPrimaryExistingRegistration = (state) =>
    state.existingRegistrations[0];

export default slice.reducer;
